import { reactive, toRefs } from 'vue';
import { useAuthStore } from './store/stores/useAuthStore.js';

import api from './core/api.js';
import { join } from './utils/urls.js';

const apis = {
	internal: import.meta.env.VITE_API_URL,
	public: import.meta.env.VITE_PUBLIC_URL,
	private: import.meta.env.VITE_PRIVATE_URL,
	external: '',
};

function getBaseUrl (domain, namespace = 'internal') {
	if (namespace === 'external') {
		return '';
	}

	return join([domain, apis[namespace]]);
}

export default reactive({
	...toRefs(api),
	submit (method, url, options = {}) {
		const { token, backSubdomain } = useAuthStore();

		const domainUrl = `https://${backSubdomain.value}.${import.meta.env.VITE_APP_DOMAIN}`;
		const baseUrl = options.baseUrl || getBaseUrl(domainUrl, options.namespace);
		const buildUrl = options.namespace !== 'external' ? join([baseUrl, url]) : url;

		return api.submit(method, buildUrl, {
			...options,
			headers: options.namespace !== 'external'
				? {
					...options.headers,
					Authorization: `Bearer ${token.value}`,
					RSRC: 127,
					mode: 'insecure',
				}
				: options.headers,
		});
	},
});
